import { render, staticRenderFns } from "./InsuranceProfessionals.vue?vue&type=template&id=96e53ff2"
import script from "./InsuranceProfessionals.vue?vue&type=script&lang=js"
export * from "./InsuranceProfessionals.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProfessionals.vue?vue&type=style&index=0&id=96e53ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports